import { render } from "./TotalShoppingForTheCurrentMonth.vue?vue&type=template&id=d577df28"
import script from "./TotalShoppingForTheCurrentMonth.vue?vue&type=script&lang=js"
export * from "./TotalShoppingForTheCurrentMonth.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__